import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-gray-900 min-h-screen w-full" }
const _hoisted_2 = { class: "px-4 py-8 mx-auto container max-w-6xl" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center items-center py-20"
}
const _hoisted_4 = {
  key: 1,
  class: "bg-red-900 text-white p-4 rounded-lg mb-6"
}
const _hoisted_5 = {
  key: 3,
  class: "bg-gray-800 rounded-lg p-8 text-center text-gray-400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyRatingStats = _resolveComponent("MyRatingStats")!
  const _component_MyRatingsList = _resolveComponent("MyRatingsList")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mb-8" }, [
        _createElementVNode("h1", { class: "text-3xl font-bold text-white mb-2" }, "Moje ocene"),
        _createElementVNode("p", { class: "text-gray-400" }, " Pregled svih ocena koje ste dobili kao prodavac ili kupac ")
      ], -1)),
      (_ctx.showMainLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.error), 1))
          : (_ctx.currentUser)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_MyRatingStats, {
                  stats: _ctx.ratingStats || _ctx.defaultRatingStats,
                  userRole: _ctx.userRole,
                  activeFilter: _ctx.ratingFilter,
                  onChangeRole: _ctx.handleRoleChange,
                  onChangeFilter: _ctx.handleFilterChange
                }, null, 8, ["stats", "userRole", "activeFilter", "onChangeRole", "onChangeFilter"]),
                _createVNode(_component_MyRatingsList, {
                  ratings: _ctx.filteredRatings,
                  loading: _ctx.ratingsLoading,
                  "current-page": _ctx.ratingCurrentPage,
                  meta: _ctx.ratingsMeta || _ctx.defaultMeta,
                  "user-role": _ctx.userRole,
                  "rating-filter": _ctx.ratingFilter,
                  onChangePage: _ctx.handlePageChange
                }, null, 8, ["ratings", "loading", "current-page", "meta", "user-role", "rating-filter", "onChangePage"])
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-4" }, "Morate biti ulogovani da biste videli svoje ocene.", -1)),
                _createVNode(_component_router_link, {
                  to: "/login",
                  class: "bg-blue-600 hover:bg-blue-500 text-white px-6 py-2 rounded-lg transition-colors"
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Prijavite se ")
                  ])),
                  _: 1
                })
              ]))
    ]),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      title: _ctx.toast.title,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type", "title"])
  ]))
}